import ViewController from "core/views/view.controller";

export default class SearchCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/views/search/search.controller.js